import { gql } from '@apollo/client'

export const CREATE_UPLOAD_MUTATION = gql`
  mutation createUpload($attributes: UploadInput!, $copyBlob: Boolean) {
    createUpload(attributes: $attributes, copyBlob: $copyBlob) {
      createdAt
      updatedAt
      attachmentUrl
      attachmentFilename
    }
  }
`
